__turbopack_context__.v({
  "text": "index-module__CVts6G__text",
});
